<template>
    <div class="header">
        <table class="table">
            <tr>
                <td>渠道ID：</td>
                <td style="padding-right: 30px">
                    <el-input
                            v-model="payChannelId"
                            size="medium"
                            @blur="searchPayChannel()"
                            placeholder="请输入代充渠道ID"/>
                </td>
                <td>充豆类型：</td>
                <td>
                    <el-select size="medium" v-model="form.rechargeType">
                        <el-option
                                v-for="item of rechargeTypeOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </td>
                <td style="padding-left: 30px">申请人：</td>
                <td>
                    <el-input placeholder="请输入" size="medium" v-model="form.applicant"/>
                </td>
            </tr>
            <tr>
                <td>渠道昵称：</td>
                <td v-text="payChannelInfo.payChannelName"></td>
                <td>充豆状态：</td>
                <td>
                    <el-select :disabled="form.rechargeType === 3" size="medium" v-model="form.rechargeStatus">
                        <el-option
                                v-for="item of rechargeStatusOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </td>
                <td style="padding-left: 30px">审批人：</td>
                <td>
                    <el-input placeholder="请输入" size="medium" v-model="form.approver"/>
                </td>
            </tr>
            <tr>
                <td colspan="2" v-text="`渠道金豆余额：${payChannelInfo.payChannelChip}`"></td>
                <td>充豆数量：</td>
                <td colspan="3">
                    <el-input
                            style="width: 200px;"
                            placeholder="请输入"
                            size="medium"
                            type="number"
                            v-model="form.rechargeChip">
                        <span slot="append">最大数位提示：{{form.rechargeChip | numberUnit}}</span>
                    </el-input>
                    <el-button style="float: right" size="medium" type="primary" @click="showPopup">确定</el-button>
                </td>
            </tr>
        </table>
        <div v-show="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>充豆</h3>
                <el-form ref="rechargeForm" :model="form" :rules="rules" class="common-popup-table" size="medium"
                         label-width="90px">
                    <el-form-item label="验证码：" prop="smsCode">
                        <el-input v-model="form.smsCode">
                            <btn-countdown
                                    slot="append"
                                    @my-click="sendCodeToMyPhone({err:$event.err,type:11})"/>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark">
                        <el-input v-model="form.remark"></el-input>
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('rechargeForm')">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('rechargeForm')">确认</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import btnCountdown from 'components/btnCountdown'

    export default {
        components: {
            btnCountdown
        },
        data() {
            return {
                show: false,
                payChannelId: '',// 渠道ID
                payChannelInfo: {// 渠道信息
                    payChannelChip: '',
                    payChannelName: '',
                    payChannelId: '',
                },
                rechargeChip: '',
                form: {
                    applicant: '',//申请人
                    approver: '',//审批人
                    rechargeChip: '',// 充豆金额
                    rechargeStatus: 1,// 充豆状态
                    rechargeType: 1,// 充豆类型
                    replenishmentNo: '',// 补单订单号
                    smsCode: '',
                    remark: '',
                },
                rules: {
                    smsCode: [
                        {required: true, message: '请输入验证码', trigger: 'blur'}
                    ]
                },
                rechargeTypeOptions: [
                    {label: '手工收费', value: 1},
                    {label: '手工扣豆', value: 2},
                    {label: '赠送', value: 3},
                ],
                rechargeStatusOptions: [
                    {label: '已收', value: 1},
                    {label: '未收', value: 2},
                ]
            }
        },
        methods: {
            ...mapActions('other', ['sendCodeToMyPhone']),
            ...mapActions('manualRechargePayChannelChip', ['getPayChannelInfo', 'doManualRecharge']),
            searchPayChannel() {
                if (!this.payChannelId) {
                    return
                }
                this.getPayChannelInfo({
                    payChannelId: this.payChannelId
                }).then(res => {
                    this.payChannelInfo = res.data
                }).catch(() => {
                    this.payChannelInfo = {
                        payChannelChip: '',
                        payChannelName: '',
                        payChannelId: '',
                    }
                })
            },
            showPopup() {
                if (!this.payChannelInfo.payChannelId) {
                    this.$message.info('渠道ID错误');
                    return
                }
                if (!this.form.rechargeChip) {
                    this.$message.info('请输入充豆数量');
                    return
                }
                if (this.form.rechargeType === 2) {
                    if (this.form.rechargeChip >= 0) {
                        this.$message.error('手工扣豆的充豆数量应小于0');
                        return
                    }
                } else {
                    if (this.form.rechargeChip <= 0) {
                        this.$message.error('充豆数量应大于0');
                        return
                    }
                }
                if (this.form.rechargeChip >= 100000000) {
                    this.$message.info('赠送数量超出范围');
                    return
                }
                this.show = true;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = this.form;
                        params.payChannelId = this.payChannelInfo.payChannelId;
                        this.doManualRecharge(params).then(() => {
                            this.$message.success('充值成功');
                            this.close(formName);
                            this.$emit('my-submit')
                        })
                    }
                });
            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        padding: 10px;
        border: 1px solid $border-color;
        box-shadow: $box-shadow;
    }

    .table {
        :global(.el-input__inner) {
            width: 180px;
        }
        @media (min-width: 1350px) {
            :global(.el-input__inner) {
                width: 200px;
            }
        }
        @media (min-width: 1450px) {
            :global(.el-input__inner) {
                width: 240px;
            }
        }
        @media (min-width: 1600px) {
            :global(.el-input__inner) {
                width: 280px;
            }
        }
    }
</style>